<template>
  <div class="container mx-auto px-8 pt-16 lg:px-16">
    <h2 id="timeline" class="font-raleway text-2xl font-light">
      Notre histoire
    </h2>
    <hr class="border mb-10 border-green-500" />

    <div class="timelineContainer">
      <div>
        <div class="borderDiv"></div>
        <div class="timelineContent">
          <div>
            <img src="@/assets/img/timeline/memoire.jpg" alt />
          </div>
          <ul>
            <li>JUIN 2018</li>
            <li class="text-green-500">
              Mémoire Leslie Moinet e-artsup promo 2018
              <br />
              <em
                >Comment la technologie peut-elle améliorer le bien-être et la
                relation Maître-Animal ?</em
              >
            </li>
          </ul>
        </div>
      </div>

      <div>
        <div class="borderDiv"></div>
        <div class="timelineSmallContent">
          <ul>
            <li>OCTOBRE 2018</li>
            <li class="text-green-500">Rencontre avec Thierry BEDOSSA</li>
          </ul>
          <div>
            <img src="@/assets/img/timeline/thierryBedossa.jpg" alt />
          </div>
        </div>
      </div>

      <div>
        <div class="borderDiv"></div>
        <div class="timelineDot">
          <div></div>
          <ul>
            <li>AVRIL à JUIN 2019</li>
            <li class="text-green-500">
              Installation et maintenance du collier pour "
              <span class="italic">La&nbsp;Vie Secrète des&nbsp;Chats</span>"
            </li>
          </ul>
        </div>
      </div>

      <div>
        <div class="borderDiv"></div>
        <div class="timelineContent">
          <ul>
            <li>JUIN 2019</li>
            <li class="text-green-500">
              Leslie MOINET, Blackfoot et Thierry BEDOSSA s’associent
            </li>
          </ul>
          <div>
            <img src="@/assets/img/timeline/team.jpg" alt />
          </div>
        </div>
      </div>

      <div>
        <div class="borderDiv"></div>
        <div class="timelineSmallContent">
          <div>
            <img src="@/assets/img/timeline/lvsdc.jpg" alt />
          </div>
          <ul>
            <li>SAMEDI 5 OCTOBRE 2019</li>
            <li class="text-green-500">
              Premier épisode de “
              <span class="italic">La&nbsp;Vie Secrète des&nbsp;Chats</span>”
            </li>
          </ul>
        </div>
      </div>

      <div>
        <div class="borderDiv"></div>
        <div class="timelineSmallContent">
          <ul class>
            <li>5 FÉVRIER 2020</li>
            <li class="text-green-500">
              Lancement de la campagne de financement participatif (pré série de
              200 colliers)
            </li>
          </ul>
          <div>
            <img src="@/assets/img/timeline/kisskiss.jpg" alt />
          </div>
        </div>
      </div>

      <div>
        <div class="borderDiv"></div>
        <div class="timelineDot">
          <div></div>
          <ul>
            <li>MI-MARS 2020</li>
            <li class="text-green-500">
              Fin de la campagne de financement participatif
            </li>
          </ul>
        </div>
      </div>

      <div>
        <div class="borderDiv"></div>
        <div class="timelineDot">
          <ul class="w-full md:w-1/2">
            <li>MAI 2020</li>
            <li class="text-green-500">Production de la pré-série</li>
          </ul>
          <div></div>
        </div>
      </div>

      <div style="width: calc(50% - 3.25em)" class="ml-auto">
        <div class="borderDiv"></div>
      </div>
    </div>

    <div
      class="mx-auto mb-4 h-40 w-40 flex-shrink-0 flex-grow-0 overflow-hidden rounded-full border-4 border-green-500 bg-red-500 md:h-48 md:w-48"
    >
      <img src="@/assets/img/timeline/kit.jpg" alt />
    </div>
    <ul class="text-center">
      <li>Q3 2020</li>
      <li class="text-green-500">Livraison du MVP</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Timeline",
};
</script>

<style>
:root {
  --rectangle-margin: 45px;
  --border-rad: 50px;
  --border-width: 4px;
}

.timelineContainer {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  padding-left: 25%;
  padding-right: 25%;
}

.timelineContainer > div {
  position: relative;
  width: 100%;
  border-top: var(--border-width) solid;
  min-height: 50px;
  box-sizing: content-box;
  @apply border-green-500;
}

.timelineContainer > div:first-child {
  border-top: none;
}

.timelineContainer > div:first-child .borderDiv {
  border-top: none;
  border-top-left-radius: 0;
  top: 0px;
}

.timelineContainer > div:nth-child(odd) .borderDiv {
  right: 100%;
  border-right: none;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  z-index: 0;
}

.timelineContainer > div:nth-child(odd) .timelineContent {
  position: relative;
  left: -7rem;
  z-index: 1;
  width: 150%;
  @apply my-12 flex items-center px-4;
}

.timelineContainer > div:nth-child(odd) .timelineContent > div {
  @apply mr-4 h-20 w-20 flex-shrink-0 overflow-hidden rounded-full border-4 border-green-500 bg-red-500;
}

@media (min-width: 768px) {
  .timelineContainer > div:nth-child(odd) .timelineContent {
    width: 66.6666%;
    left: -8.4rem;
  }
  .timelineContainer > div:nth-child(odd) .timelineContent > div {
    @apply h-32 w-32;
  }
}

.timelineContainer > div:nth-child(odd) .timelineSmallContent {
  position: relative;
  left: -6rem;
  z-index: 1;
  width: 150%;
  @apply my-12 flex items-center px-4;
}

.timelineContainer > div:nth-child(odd) .timelineSmallContent > div {
  @apply mr-4 h-12 w-12 flex-shrink-0 overflow-hidden rounded-full border-4 border-green-500 bg-red-500;
}

@media (min-width: 768px) {
  .timelineContainer > div:nth-child(odd) .timelineSmallContent {
    width: 66.6666%;
    left: -7rem;
  }
  .timelineContainer > div:nth-child(odd) .timelineSmallContent > div {
    @apply h-20 w-20;
  }
}

.timelineContainer > div:nth-child(odd) .timelineDot {
  position: relative;
  left: -4.7rem;
  z-index: 1;
  width: 150%;
  @apply my-12 flex items-center px-4;
}

@media (min-width: 768px) {
  .timelineContainer > div:nth-child(odd) .timelineDot {
    width: 66.6666%;
  }
}

.timelineContainer > div:nth-child(odd) .timelineDot > div {
  @apply mr-4 h-0 w-0 flex-shrink-0 overflow-hidden rounded-full border-8 border-green-500 bg-red-500;
}

.timelineContainer > div:nth-child(even) .borderDiv {
  left: 100%;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-left: none;
  z-index: 0;
}

.timelineContainer > div:nth-child(even) .timelineContent {
  position: relative;
  right: -7rem;
  z-index: 1;
  width: 150%;
  justify-content: flex-end;
  @apply float-right my-12 flex items-center px-4 text-right;
}

.timelineContainer > div:nth-child(even) .timelineContent > div {
  @apply ml-4 h-20 w-20 flex-shrink-0 overflow-hidden rounded-full border-4 border-green-500 bg-red-500;
}

@media (min-width: 768px) {
  .timelineContainer > div:nth-child(even) .timelineContent {
    width: 66.6666%;
    right: -8.4rem;
  }
  .timelineContainer > div:nth-child(even) .timelineContent > div {
    @apply h-32 w-32;
  }
}

.timelineContainer > div:nth-child(even) .timelineSmallContent {
  position: relative;
  right: -6rem;
  z-index: 1;
  width: 150%;
  justify-content: flex-end;
  @apply float-right my-12 flex items-center px-4 text-right;
}

.timelineContainer > div:nth-child(even) .timelineSmallContent > div {
  @apply ml-4 h-12 w-12 flex-shrink-0 overflow-hidden rounded-full border-4 border-green-500 bg-red-500;
}

@media (min-width: 768px) {
  .timelineContainer > div:nth-child(even) .timelineSmallContent {
    width: 66.6666%;
    right: -7rem;
  }
  .timelineContainer > div:nth-child(even) .timelineSmallContent > div {
    @apply h-20 w-20;
  }
}

.timelineContainer > div:nth-child(even) .timelineDot {
  position: relative;
  right: -4.7rem;
  z-index: 1;
  width: 150%;
  justify-content: flex-end;
  @apply float-right my-12 flex items-center justify-end px-4 text-right;
}

@media (min-width: 768px) {
  .timelineContainer > div:nth-child(even) .timelineDot {
    width: 66.6666%;
  }
}

.timelineContainer > div:nth-child(even) .timelineDot > div {
  @apply ml-4 h-0 w-0 flex-shrink-0 overflow-hidden rounded-full border-8 border-green-500 bg-red-500;
}

.timelineContainer > div:last-child {
  border-bottom: none;
  @apply border-green-500;
}

.timelineContainer > div:last-child .borderDiv {
  border-bottom-left-radius: 0;
  border-bottom: none;
}

.borderDiv {
  border: var(--border-width) solid;
  position: absolute;
  height: 100%;
  width: var(--border-rad);
  top: calc(-1 * var(--border-width));
  border-radius: var(--border-rad);
  @apply border-green-500;
}
</style>
